import React from 'react';
import { connect } from 'react-redux';

import CommonNavItem from '../../Common/CommonNavItem/CommonNavItem';
import HeadingH4 from '../../../UI/Headings/HeadingH4/HeadingH4';

import * as farePriceActions from '../../../../store/actions/index';

const baggageNav = (props) =>  {
    const baggageKeys = Object.keys(props.baggage).filter((keyCode) => {
        return props.baggage[keyCode].baggageOptions.length !== 0;
    });
    return (
        <React.Fragment>
            <div className={`mr-6 phone-mb-2`}>
                <HeadingH4 size={11} textUpper={true} weight="Medium" color="Dark">{props.type === 'depart' ? 'Depart' : 'Return'}</HeadingH4>
            </div>
            <nav>
                <ul className={`u-flex`}>
                    { baggageKeys.map((baggage, index) => {
                        return <CommonNavItem key={baggage} onClick={() => props.onToggleBaggageView(baggage, props.type, index)} active={props.baggageView === baggage && (props.flow === props.baggageFlow) ? 'true' : 'false'}>{baggage.replace('|', ' - ')}</CommonNavItem>
                    })} 
                </ul>
            </nav>
        </React.Fragment>
    );
}   

const mapDispatchToProps = dispatch => {
    return {
        onToggleBaggageView: (view, tripType, index) => dispatch(farePriceActions.toggleBaggageView(view, tripType, index))
    }
}

export default connect(null, mapDispatchToProps)(baggageNav);


// WEBPACK FOOTER //
// ./src/components/Addons/Baggage/BaggageNav/BaggageNav.js